import { defineStore } from "pinia";
import { noTokenHttp } from "@utils/http";

// 测试打包同样是 production 构建，不能使用 import.meta.env.PROD 区分。
const hideProductionPrintOptions = ["prod", "production"].includes(import.meta.env.MODE);
const hiddenProductionPrintTypes = ["SLM", "MJF", "DLP", "SLA"];

export const usePropsStore = defineStore("props", {
  state: () => {
    return {
      PropsList: [
        {
          label: "塑料",
          strengths: [
            {
              label: "低",
              precisions: [
                {
                  label: "中",
                  method: "SLA",
                  printId: 2,
                  colors: [
                    {
                      label: "乳白色",
                      style: "linear-gradient(to right,#F8F6EB,#F8F6EB)",
                      value: [13, 38, 17, 9, 19, 2],
                    },
                    {
                      label: "黑色",
                      style: "linear-gradient(to right,#2E2E2D,#2E2E2D)",
                      value: [13, 38, 17, 75, 19, 2],
                    },
                    {
                      label: "磨砂",
                      style:
                        "linear-gradient(to bottom,#8E8E8E,#FFFFFF,#717171)",
                      value: [13, 38, 17, 76, 19, 2],
                    },
                    {
                      label: "高透明",
                      style: "linear-gradient(to bottom,#ffffff,#ffffff)",
                      value: [13, 38, 17, 77, 19, 2],
                    },
                  ],
                },
                {
                  label: "高",
                  method: "DLP",
                  printId: 1,
                  colors: [
                    {
                      label: "橘红色",
                      style: "linear-gradient(to right,#DE591D,#DE591D)",
                      value: [13, 38, 18, 10, 19, 1],
                    },
                  ],
                },
              ],
            },
            {
              label: "中",
              precisions: [
                {
                  label: "低",
                  method: "FDM",
                  printId: 3,
                  colors: [
                    {
                      label: "红色",
                      style:
                        "repeating-linear-gradient(to bottom,#D33328 0px, #D33328 1px,#EE392C 1px, #EE392C 2px)",
                      value: [13, 39, 27, 33, 19, 3],
                    },
                    {
                      label: "黄色",
                      style:
                        "repeating-linear-gradient(to bottom,#DCD350 0px, #DCD350 1px,#F8EE59 1px,#F8EE59 2px)",
                      value: [13, 39, 27, 34, 19, 3],
                    },
                    {
                      label: "蓝色",
                      style:
                        "repeating-linear-gradient(to bottom,#0F50A4 0px, #0F50A4 1px,#1059B9 1px, #1059B9 2px)",
                      value: [13, 39, 27, 35, 19, 3],
                    },
                    {
                      label: "绿色",
                      style:
                        "repeating-linear-gradient(to bottom,#669B5B 0px,#669B5B 1px,#72AE66 1px,#72AE66 2px)",
                      value: [13, 39, 27, 36, 19, 3],
                    },
                    {
                      label: "黑色",
                      style:
                        "repeating-linear-gradient(to bottom,#2D2E32 0px, #2D2E32 1px,#323337 1px, #323337 2px)",
                      value: [13, 39, 27, 72, 19, 3],
                    },
                    {
                      label: "白色",
                      style:
                        "repeating-linear-gradient(to bottom,#E4E1D9 0px, #E4E1D9 1px,#E6D8C0 1px, #E6D8C0 2px)",
                      value: [13, 39, 27, 73, 19, 3],
                    },
                    {
                      label: "夜光色",
                      style:
                        "repeating-linear-gradient(to bottom,#B4CBD6 0px,#B4CBD6 1px,#C1E1F1 1px, #C1E1F1 2px)",
                      value: [13, 39, 27, 74, 19, 3],
                    },
                  ],
                },
                {
                  label: "高",
                  method: "MJF",
                  printId: 4,
                  colors: [
                    {
                      label: "尼龙",
                      style: "linear-gradient(to right,#646464,#646464)",
                      value: [13, 40, 17, 31, 19, 4],
                    },
                  ],
                },
              ],
            },
          ],
        },
        {
          label: "金属",
          strengths: [
            {
              label: "高",
              precisions: [
                {
                  label: "中",
                  method: "SLM",
                  printId: 5,
                  colors: [
                    {
                      label: "铝合金",
                      style:
                        "linear-gradient(to bottom,#8C8C8C,#FFFFFF,#898888)",
                      value: [26, 41, 17, 32, 19, 5],
                    },
                  ],
                },
              ],
            },
          ],
        },
      ],
      PropsMapping: {
        // 塑料-低-中-SLA系列
        "[13,38,17,9,19,2]": [
          "塑料",
          "低",
          "中",
          "SLA",
          "linear-gradient(to right,#F8F6EB,#F8F6EB)",
        ],
        "[13,38,17,75,19,2]": [
          "塑料",
          "低",
          "中",
          "SLA",
          "linear-gradient(to right,#2E2E2D,#2E2E2D)",
        ],
        "[13,38,17,76,19,2]": [
          "塑料",
          "低",
          "中",
          "SLA",
          "linear-gradient(to bottom,#8E8E8E,#FFFFFF,#717171)",
        ],
        "[13,38,17,77,19,2]": [
          "塑料",
          "低",
          "中",
          "SLA",
          "linear-gradient(to bottom,#ffffff,#ffffff)",
        ],
        // 塑料-低-高-DLP系列
        "[13,38,18,10,19,1]": [
          "塑料",
          "低",
          "高",
          "DLP",
          "linear-gradient(to right,#DE591D,#DE591D)",
        ],
        // 塑料-中-低-FDM系列
        "[13,39,27,33,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#D33328 0px, #D33328 1px,#EE392C 1px, #EE392C 2px)",
        ],
        "[13,39,27,34,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#DCD350 0px, #DCD350 1px,#F8EE59 1px,#F8EE59 2px)",
        ],
        "[13,39,27,35,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#0F50A4 0px, #0F50A4 1px,#1059B9 1px, #1059B9 2px)",
        ],
        "[13,39,27,36,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#669B5B 0px,#669B5B 1px,#72AE66 1px,#72AE66 2px)",
        ],
        "[13,39,27,72,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#2D2E32 0px, #2D2E32 1px,#323337 1px, #323337 2px)",
        ],
        "[13,39,27,73,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#E4E1D9 0px, #E4E1D9 1px,#E6D8C0 1px, #E6D8C0 2px)",
        ],
        "[13,39,27,74,19,3]": [
          "塑料",
          "中",
          "低",
          "FDM",
          "repeating-linear-gradient(to bottom,#B4CBD6 0px,#B4CBD6 1px,#C1E1F1 1px, #C1E1F1 2px)",
        ],
        // 塑料-中-高-MJF系列
        "[13,40,17,31,19,4]": [
          "塑料",
          "中",
          "高",
          "MJF",
          "linear-gradient(to right,#646464,#646464)",
        ],
        // 金属-高-中-SLM系列
        "[26,41,17,32,19,5]": [
          "金属",
          "高",
          "中",
          "SLM",
          "linear-gradient(to bottom,#8C8C8C,#FFFFFF,#898888)",
        ],
      },
      isLoading: false,
      selectedMaterial: "塑料",
      selectedStrength: "低",
      selectedPrecision: "中",
      selectedColor: null,
      selectedPrint: null,
      selectedPrintId: null, //打印方式对应的id
      printParamLevel: null, // 打印方式参数等级
      selectedGridNum: [30, 30, 30],
      num: 1,
      printName: {
        SLA: "塑料",
        DLP: "塑料",
        FDM: "塑料",
        FDM1: "塑料",
        MJF: "塑料",
        SLM: "金属",
      },
      selectedValue: [],
    };
  },
  getters: {
    selectablePropsList() {
      if (!hideProductionPrintOptions) return this.PropsList;
      // 保留原始属性及映射供历史商品回显，只收窄可选项。
      return this.PropsList.map((material) => ({
        ...material,
        strengths: material.strengths.map((strength) => ({
          ...strength,
          precisions: strength.precisions
            .filter((precision) => !hiddenProductionPrintTypes.includes(precision.method))
            .map((precision) => ({
              ...precision,
              colors: precision.colors.filter((color) =>
                precision.method !== "SLA" || !["磨砂", "高透明", "透明"].includes(color.label),
              ),
            }))
            .filter((precision) => precision.colors.length > 0),
        })).filter((strength) => strength.precisions.length > 0),
      })).filter((material) => material.strengths.length > 0);
    },
    materials() {
      return this.selectablePropsList.map((item) => item.label) || [];
    },
    strengths() {
      console.log("strengths触发", this.selectedMaterial);
      if (!this.selectedMaterial) return [];
      const materialItem = this.selectablePropsList.find(
        (item) => item.label === this.selectedMaterial,
      );
      return materialItem ? materialItem.strengths.map((s) => s.label) : [];
    },
    precisions() {
      if (!this.selectedMaterial || !this.selectedStrength) return [];
      const materialItem = this.selectablePropsList.find(
        (item) => item.label === this.selectedMaterial,
      );
      if (!materialItem) return [];
      const strengthItem = materialItem.strengths.find(
        (s) => s.label === this.selectedStrength,
      );
      return strengthItem ? strengthItem.precisions.map((p) => p.label) : [];
    },
    colors() {
      if (
        !this.selectedMaterial ||
        !this.selectedStrength ||
        !this.selectedPrecision
      )
        return [];
      const materialItem = this.selectablePropsList.find(
        (item) => item.label === this.selectedMaterial,
      );
      if (!materialItem) return [];
      const strengthItem = materialItem.strengths.find(
        (s) => s.label === this.selectedStrength,
      );
      if (!strengthItem) return [];
      const precisionItem = strengthItem.precisions.find(
        (p) => p.label === this.selectedPrecision,
      );
      return precisionItem ? precisionItem.colors : [];
    },
    printTypes() {
      return Object.keys(this.printName).filter((key) =>
        !hideProductionPrintOptions || !hiddenProductionPrintTypes.includes(key),
      ).map((key) => ({
        id: key,
        label: this.printName[key],
      }));
    },
    getDefaultProps() {
      return this.selectablePropsList[0]?.strengths[0]?.precisions[0]?.colors[0] || {};
    },
    getAllProps() {
      return this.selectedValue;
    },
  },
  actions: {
    async fetchPrintParamLevel() {
      try {
        this.isLoading = true;
        const res = await noTokenHttp.get(
          "/api/user-api/prod/getPrintParamLevel",
          {},
        );
        this.printParamLevel = res.data.data;
      } catch (error) {
        console.error("获取打印参数失败：", error);
      } finally {
        this.isLoading = false;
      }
    },
    setSelectedProps(selectedValue) {
      console.log("传入", selectedValue);
      const normalizePropsValue = (value) => {
        if (Array.isArray(value)) return value.map(Number).filter((item) => Number.isFinite(item));
        if (typeof value === "string") return value.split(",").map(Number).filter((item) => Number.isFinite(item));
        return [];
      };
      // 定义匹配逻辑
      const isMatched = (colorValue, targetValue) => {
        const colorVal = normalizePropsValue(colorValue);
        const targetVal = normalizePropsValue(targetValue);
        if (colorVal.length < 5 || targetVal.length < 5) return false;

        // 核心匹配规则：
        // - 前4位必须完全一致
        // - 第5位兼容19/20
        // - 目标值为6位时必须匹配第6位printId；目标值为5位时按旧数据兼容处理
        const baseMatched =
          colorVal[0] === targetVal[0] &&
          colorVal[1] === targetVal[1] &&
          colorVal[2] === targetVal[2] &&
          colorVal[3] === targetVal[3] &&
          [19, 20].includes(colorVal[4]) &&
          [19, 20].includes(targetVal[4]);

        if (!baseMatched) return false;
        if (targetVal.length >= 6) return colorVal[5] === targetVal[5];
        return true;
      };

      // 遍历匹配属性
      let isFound = false;
      for (const material of this.PropsList) {
        for (const strength of material.strengths) {
          for (const precision of strength.precisions) {
            for (const color of precision.colors) {
              // 关键：判断当前color.value是否和传入的selectedValue匹配
              if (isMatched(color.value, selectedValue)) {
                this.selectedMaterial = material.label;
                this.selectedStrength = strength.label;
                this.selectedPrecision = precision.label;
                this.selectedColor = color;
                // 转换为纯数组（解决IndexedDB克隆问题）
                this.selectedValue = JSON.parse(JSON.stringify(color.value));
                this.selectedPrint = precision.method;
                this.selectedPrintId = precision.printId;
                console.log(
                  "匹配到值：",
                  this.selectedValue,
                  "传入值：",
                  selectedValue,
                  this.selectedStrength,
                  this.selectedPrecision,
                );
                isFound = true;
                return; // 匹配成功，立即退出
              }
            }
          }
          if (isFound) break;
        }
        if (isFound) break;
      }
      if (!isFound) {
        console.warn("未匹配到分件属性，保留当前属性：", selectedValue);
      }
    },
    async initDefaultProps() {
      try {
        const firstMaterialItem = this.selectablePropsList[0];
        if (firstMaterialItem) {
          // 1. 设置材质
          this.selectedMaterial = firstMaterialItem.label;
          console.log("设置材质", this.selectedMaterial);

          const firstStrengthItem = firstMaterialItem.strengths[0];
          if (firstStrengthItem) {
            // 2. 设置强度
            this.selectedStrength = firstStrengthItem.label;

            const firstPrecisionItem = firstStrengthItem.precisions[0];
            if (firstPrecisionItem) {
              // 3. 设置精度
              this.selectedPrecision = firstPrecisionItem.label;

              const firstColorItem = firstPrecisionItem.colors[0];
              if (firstColorItem) {
                // 4. 设置颜色
                this.selectedColor = firstColorItem;
                this.selectedValue = firstColorItem.value || [];
                console.log("color", this.selectedValue);
                // 5. 设置打印方式
                this.selectedPrint = firstPrecisionItem.method;
                this.selectedPrintId = firstPrecisionItem.printId;
              }
            }
          }
        }
        this.num = 1;
        console.log("初始化默认值完成：", this.getAllProps);
        return this.getAllProps;
      } catch (error) {
        console.error("初始化默认属性失败：", error);
        this.resetProps();
        throw error;
      }
    },
    // 实时获取当前属性操作后的 printType,printingModeId,props
    getNowPorps() {
      return {
        printType: this.selectedPrint,
        printingModeId: this.selectedPrintId,
        props: this.getAllProps,
      };
    },
    resetProps() {
      this.selectedMaterial = null;
      this.selectedStrength = null;
      this.selectedPrecision = null;
      this.selectedColor = null;
      this.selectedPrint = null;
      this.selectedPrintId = null;
      this.selectedValue = [];
    },
  },
});
